<template>
  <div class="table-responsive table-full-width modal-overflow">
    <el-table :data="logs"
              highlight-current-row
              row-key="id"
              border
              style="width: 100%">
      <el-table-column
        label="Message"
        prop="message"
        min-width="200">
      </el-table-column>
      <el-table-column
        label="level"
        prop="level"
        min-width="80">
        <template slot-scope="props">
          {{ capitalize1stLetter(props.row.level) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Date"
        min-width="100">
        <template slot-scope="props">
          {{ props.row.createdAt | formatDateTime }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {OK} from 'http-status-codes'
  import {capitalizeFirstLetter} from 'src/utilities/utils'

  export default {
    props: ['data'],
    data() {
      return {
        logs: [],
      }
    },
    methods: {
      capitalize1stLetter(text) {
        return capitalizeFirstLetter(text)
      }
    },
    async beforeMount() {
      const response = await this.$store.dispatch('logs/fetchByEntityTypeAndEntityId', this.data)

      if (OK === response.status) {
        this.logs = response.data
      }
    }
  }
</script>
